<template>
  <div class="space-y-4 p-6 text-ontick-graphite-900 dark:text-gray-300">
    <div
      class="flex w-full items-center justify-center border-b-2 border-ontick-steel-300 py-4 dark:border-ontick-steel-500"
    >
      <span class="text-3xl font-bold">Solicitar vínculo</span>
    </div>
    <div class="space-y-6">
      <div class="flex flex-col space-y-2">
        <label for="partner">Parceiro</label>
        <div class="relative w-full">
          <input
            type="text"
            id="partner"
            class="w-full rounded-lg border-none bg-ontick-steel-100 dark:bg-ontick-steel-500"
            v-model="partnerInput"
            placeholder="Procurar parceiro"
          />
          <ul
            v-if="showSuggestions"
            class="absolute top-12 left-0 z-50 max-h-52 w-full overflow-y-auto rounded-lg bg-ontick-steel-100 shadow dark:bg-ontick-steel-500"
          >
            <li
              v-for="(item, index) in searchResults"
              :key="index"
              @click="selectSuggestion(item)"
              class="p-2 hover:bg-ontick-steel-400 hover:text-white"
            >
              {{ item }}
            </li>
            <li
              class="p-2 hover:bg-ontick-steel-400 hover:text-white"
              v-if="error"
            >
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
      <div class="text-center">
        <span class="text-xl text-ontick-carbon-900 dark:text-gray-400">
          Busque e selecione o parceiro OnTick ao qual você deseja se vincular.
        </span>
      </div>
      <div class="flex items-center justify-end space-x-2">
        <ontick-button-component
          color="transparent"
          @click.native="$emit('close')"
          >Cancelar</ontick-button-component
        >
        <ontick-button-component @click.native="confirmRequest"
          >Solicitar</ontick-button-component
        >
      </div>
    </div>
  </div>
</template>

<script>
import OntickButtonComponent from "../../../shared/components/basic/ontick-button.component.vue";

export default {
  components: { OntickButtonComponent },

  data() {
    return {
      partnerInput: "",
      selectedResult: "",
      searchResults: [],
      showSuggestions: false,
      suggestionIsSelected: false,
      error: "",
    };
  },

  methods: {
    confirmRequest() {
      this.$api
        .post(this.$endpoint.REQUEST_BINDING, {
          partner_name: this.partnerInput,
        })
        .then((res) => {
          // console.log(res.data.msg);
          this.$emit("confirm");
          this.$swal({
            title: "Seu vínculo foi solicitado",
            text: "Seu pedido de vínculo foi enviado a nosso parceiro e o prazo estimado de confirmação é de 48 horas úteis. Quaisquer dúvidas entre em contato com a nossa equipe de suporte.",
          });
        })
        .catch((err) => {
          console.error(err);
          this.$swal("Erro", err.data.msg, "error");
        });
    },
    selectSuggestion(item) {
      this.partnerInput = item;
      this.suggestionIsSelected = true;
      this.showSuggestions = false;
      this.searchResults = [];
    },
    getPartnerSearch() {
      this.$api
        .get(this.$endpoint.GET_SEARCH_PARTNERS + this.partnerInput)
        .then((res) => {
          this.searchResults = res.data;
          this.error = "";
        })
        .catch((err) => {
          console.error(err);
          this.error = err.data.msg;
          this.searchResults = [];
        });
    },
  },
  watch: {
    partnerInput(val) {
      if (val.length >= 3 && !this.suggestionIsSelected) {
        this.showSuggestions = true;
        this.getPartnerSearch();
      } else if (val.length >= 3 && this.suggestionIsSelected) {
        this.showSuggestions = false;
        this.suggestionIsSelected = false;
      } else if (val.length < 3) {
        this.showSuggestions = false;
      }
    },
  },
};
</script>

<style></style>
